// extracted by mini-css-extract-plugin
export default {"a0":"QOFRSJawpcHya5sT0G1l","a1":"Y_xgmhYKlhPkHKyHVQr5","cls1":"XuPRvOxQCgUP3yJ5xFfF","cls2":"MpP0LQVH00KU414jsyFm XuPRvOxQCgUP3yJ5xFfF","centered":"Us40UQbiYUV8pMVLMtgW"};